<template>
  <div>
    <event-pc v-if="!$store.state.isMobile"></event-pc>
    <event-mobile v-else></event-mobile>
  </div>
</template>
<script>
import eventPc from './event.pc.vue'
import eventMobile from './event.mobile.vue'

export default {
  data () {
    return {}
  },
  components: {
    eventPc,
    eventMobile
  },
  computed: {}
}
</script>
<style scoped lang='sass'>
</style>
